import * as React from 'react'
import type { WorkflowIconType, WorkflowIconMode } from '../../../shared/webcomponents/zaptic-workflow-icon'
import { NonThrowingComponent } from '../../../app-core/lib/ui/NonThrowingComponent'
import { Spinner } from '../../../app-core/lib/ui/Spinner'

type TProps = {
    icon: WorkflowIconType
    mode: WorkflowIconMode
    spinning?: boolean
}

export class TodoItemIcon extends NonThrowingComponent<TProps, {}> {
    public tryRender() {
        return (
            <div className="AppCore__ui__TodoItemIcon">
                {this.props.spinning ? (
                    <Spinner />
                ) : (
                    <zaptic-workflow-icon type={this.props.icon} mode={this.props.mode}></zaptic-workflow-icon>
                )}
            </div>
        )
    }
}
